export default __webpack_public_path__ + "images/e0ad4076c32c79ecc5259ebad50a51a8-exercise_small.webp";